module.exports = __webpack_public_path__ + "assets/new-youtube.2bbe0556.svg";